import { useEffect, useState } from 'react';
import { Avatar, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "../../services/api";
import { makeStyles } from "@material-ui/core";
import { useDispatch, useSelector } from 'react-redux';
import Paginacao from '../../utils/paginacao';
// import SearshEmpresa from './searshEmpresa';
import RegisterAccess from '../../utils/registerAccess';
import { RelatorioEmpresasPdf } from '../exports/gerarelatoriopdf';
import { RelatorioEmpresasExcel } from '../exports/gerarelatorioexcel';
import HeaderSession from '../../utils/headerSession';
import TabelaLoading from '../../load/tabelaLoading';
import EmpresaFilter from '../../filters/empresaFilter';


const useStyles = makeStyles((theme) => ({
    hover: { '&:hover': { backgroundColor: '#d2d6ff' }, cursor: 'pointer' }
}))

export default function Empresas() {
    const classes = useStyles()
    const navigate = useNavigate()
    const [empresas, setEmpresas] = useState(useSelector(state => state?.empresas?.data) ?? '')
    const [configLista, setConfigLista] = useState(useSelector(state => state?.empresas?.config) ?? '')
    const dispatch = useDispatch();
    const [perPage, setPerPage] = useState(20)
    const [order, setOrder] = useState('ASC')
    const [loading, setLoading] = useState(false);
    const [searchParams] = useSearchParams();
    const [page, setPage] = useState(searchParams.get("page"));

    useEffect(() => {
        setLoading(true)
        api.get(`/empresas?page=${page}&perPage=${perPage}&sortBy=createdAt:${order}`)
            .then(response => {
                // console.log(response)
                setConfigLista(response.data);
                // setEmpresas((prevItems) => [...prevItems, ...response.data.empresas]);
                setEmpresas(response.data.empresas);

                setLoading(false)
            }).catch(err => { setLoading(false) })

        dispatch({
            type: 'empresas',
            payload: { empresas: empresas, config: configLista },
        }); //dispatch para por as empresas no state da aplicacao e evitar recarregar desnecessariamente

    }, [page, perPage, order]);

    return (
        <>
            <RegisterAccess page={'lista de empresas registadas'} />

            <HeaderSession
                title='EMPRESAS REGISTADAS'
                actions={true}
                handleExportExcel={() => RelatorioEmpresasExcel(empresas)}
                handleExportPDF={() => RelatorioEmpresasPdf(empresas)}
            />

            {/* <SearshEmpresa setEmpresas={setEmpresas} /> */}

            {empresas &&
                <TableContainer sx={{ border: "1px black" }} component={Paper}>
                    <Table sx={{ border: "1px", borderColor: "black" }}>
                        <TableHead sx={{ backgroundColor: "#dcdede" }}>
                            <TableRow>
                                <TableCell  ><Typography noWrap> <strong>Logotipo</strong></Typography></TableCell>
                                <TableCell><Typography noWrap display={'flex'}>
                                    <strong>Nome</strong>
                                    <EmpresaFilter setEmpresas={setEmpresas} setLoading={setLoading} />
                                </Typography></TableCell>
                                <TableCell><Typography noWrap display={'flex'}>
                                    <strong>Nif</strong>
                                    <EmpresaFilter setEmpresas={setEmpresas} setLoading={setLoading} />
                                </Typography></TableCell>
                                {/* <TableCell align="center" ><Typography noWrap> <strong>Processo</strong></Typography></TableCell> */}
                                {/* <TableCell align="center" ><Typography noWrap> <strong>Telefone</strong></Typography></TableCell> */}
                                <TableCell  ><Typography noWrap> <strong>Provincia</strong></Typography></TableCell>
                                <TableCell  ><Typography noWrap> <strong>Municipio</strong></Typography></TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {empresas.map((empresa => (
                                <TableRow key={empresa?._id} onClick={() => navigate(`/admin/get-empresa/${empresa._id}`)} className={classes.hover}>

                                    <TableCell align="center" >
                                        <Avatar variant="square" src={empresa?.logo} />
                                    </TableCell>

                                    <TableCell >{empresa?.nome}</TableCell>
                                    <TableCell > <Typography noWrap> {empresa?.nif}</Typography></TableCell>
                                    {/* <TableCell > <Typography noWrap> {empresa?.numeroProcesso}</Typography></TableCell> */}
                                    {/* <TableCell > <Typography noWrap> {empresa?.tel1}</Typography></TableCell> */}
                                    <TableCell > <Typography noWrap> {empresa?.provincia}</Typography></TableCell>
                                    <TableCell > <Typography noWrap> {empresa?.municipio}</Typography></TableCell>

                                </TableRow>
                            )))}
                        </TableBody>
                    </Table>

                    <Paginacao
                        configLista={configLista}
                        lista={empresas}
                        page={page}
                        setPage={setPage}
                        setPerPage={setPerPage}
                        setOrder={setOrder}
                    />
                </TableContainer>
            }

            {loading && <TabelaLoading />}
        </>

    )
}